import { render, staticRenderFns } from "./bindCustomer.vue?vue&type=template&id=38df8e70&scoped=true&"
import script from "./bindCustomer.vue?vue&type=script&lang=js&"
export * from "./bindCustomer.vue?vue&type=script&lang=js&"
import style0 from "./bindCustomer.vue?vue&type=style&index=0&id=38df8e70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38df8e70",
  null
  
)

export default component.exports